export default {
  salesDecomposition: 'Descomposición de {kpi}',
  dataView: 'Vista de Datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como Imagen',
  base: 'Base',
  carryOverMarketing: 'Marketing Residual',
  instantMarketing: 'Marketing Instantáneo',
  noise: 'Ruido',
  seasonality: 'Estacionalidad',
  external: 'Externo',
  total: 'Total'
}
